import { render } from "./MemberPortalNavigation.vue?vue&type=template&id=8e210252&scoped=true"
import script from "./MemberPortalNavigation.vue?vue&type=script&lang=js"
export * from "./MemberPortalNavigation.vue?vue&type=script&lang=js"

import "./MemberPortalNavigation.vue?vue&type=style&index=0&id=8e210252&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e210252"]])

export default __exports__